import { Box, Grid, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";

import CustomMap from "../../map/CustomMap";
import RequestDetailField from "./RequestDetailField";

const Section = ({ title, children }) => (
  <Paper variant="outlined" sx={{ p: 1.25, height: "100%" }}>
    <Typography
      variant="caption"
      color="text.secondary"
      fontWeight={700}
      display="block"
      sx={{ mb: 0.75 }}
    >
      {title}
    </Typography>
    <Grid container spacing={1}>
      {children}
    </Grid>
  </Paper>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

const RequestTechnicalInfoTab = ({ request, mapCenter, hasCoords }) => {
  if (!request) return null;

  const areaDisplay =
    request.installableAreaSquareMeter != null
      ? `${request.installableAreaSquareMeter} m²`
      : null;

  return (
    <Grid container spacing={1.25}>
      <Grid item xs={12} md={6}>
        <Section title="مشخصات نیروگاه">
          <RequestDetailField
            label="نوع نیروگاه"
            value={request.powerPlantTypeTitle}
            sm={6}
            xs={6}
          />
          <RequestDetailField
            label="ظرفیت"
            value={request.plantCapacityTitle}
            sm={6}
            xs={6}
          />
          <RequestDetailField
            label="مساحت قابل نصب"
            value={areaDisplay}
            sm={6}
            xs={6}
          />
        </Section>
      </Grid>

      <Grid item xs={12} md={6}>
        <Section title="محل و مالکیت">
          <RequestDetailField
            label="کاربری محل"
            value={request.locationUsageTypeTitle}
            sm={6}
            xs={6}
          />
          <RequestDetailField
            label="وضعیت مالکیت"
            value={request.ownershipStatusTitle}
            sm={6}
            xs={6}
          />
          <RequestDetailField
            label="هدف متقاضی"
            value={request.applicantGoalsTitle}
            sm={12}
            xs={12}
          />
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={700}
            display="block"
            sx={{ mb: 0.75 }}
          >
            موقعیت و آدرس
          </Typography>
          <Grid container spacing={1}>
            <RequestDetailField
              label="آدرس"
              value={request.address}
              fullWidth
            />
            <RequestDetailField
              label="مختصات"
              value={
                hasCoords
                  ? `${mapCenter[0]}, ${mapCenter[1]}`
                  : "ثبت نشده"
              }
              sm={12}
              xs={12}
            />
          </Grid>
          {hasCoords ? (
            <Box
              sx={{
                mt: 1,
                height: { xs: 140, sm: 160 },
                borderRadius: 1,
                overflow: "hidden",
                border: 1,
                borderColor: "divider",
                "& .leaflet-container": {
                  height: "100%",
                  width: "100%",
                },
              }}
            >
              <CustomMap
                center={mapCenter}
                zoom={14}
                height="100%"
                markerPosition={mapCenter}
                readOnly
              />
            </Box>
          ) : null}
        </Paper>
      </Grid>
    </Grid>
  );
};

RequestTechnicalInfoTab.propTypes = {
  request: PropTypes.object,
  mapCenter: PropTypes.arrayOf(PropTypes.number).isRequired,
  hasCoords: PropTypes.bool,
};

export default RequestTechnicalInfoTab;
